import styled from 'styled-components'

export const StyledEquipmentPanel = styled.div`
  width: 100%;
  height: 430px;
  margin-top: 26px;
`

export const StyledEquipmentRow = styled.div`
  width: 70%;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;

  span {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 28px;
    /* position: absolute; */
    top: 10px;
    left: 0;
    right: 0;
    margin: auto;
  }
`

export const StyledEquipmentMethod = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  legend {
    font-size: 14px;
    color: #495057;
    margin-bottom: 3px;
  }

  label {
    display: flex;
    align-items: center;
    font-size: 14px;
    margin-right: 65px;
  }
`

export const StyledInfoContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: center;
  align-items: center;
  color: #495057;
  font-size: 14px;
  line-height: 24px;
  height: 60%;
  span {
    max-width: 500px;
  }
`

export const StyledInfoIcon = styled.div`
  display: flex;
  align-items: center;
  circle {
    stroke: #044f98;
  }
  line {
    stroke: #044f98;
  }
`
